// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledTypography } from "@insite/mobius/Link";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { productPriceStyles } from "@synd/Overrides/Components/ProductPrice";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { color } from "@synd/XDL/Utilities";
import { css } from "styled-components";

const unitOfMeasureText: TypographyPresentationProps = {
    ...fontConfig.xSmallSingleLine,
    css: css`
        white-space: nowrap;
        &&& {
            color: ${color("text")};
        }
    `,
};

productPriceStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: start;
    `,
};
productPriceStyles.priceWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
        align-items: baseline;
    `,
};
productPriceStyles.price = {
    ...productPriceStyles.price,
    priceText: {
        ...productPriceStyles.price?.priceText,
        ...fontConfig.smallHeadLine,
        weight: fontConfig.weight.bold,
    },
    unitOfMeasure: {
        unitOfMeasureText,
    },
    signInText: {
        css: css`
            &,
            * {
                font-weight: ${fontConfig.weight.medium} !important;
                font-size: ${fontConfig.xSmallSingleLine.size}px !important;
                line-height: ${fontConfig.xSmallSingleLine.lineHeight} !important;
                color: ${color("text.main")};
            }
            a,
            a ${StyledTypography} {
                color: ${color("text.main")};
            }
        `,
    },
};

productPriceStyles.quoteMessage = {
    text: {
        color: "danger",
        ...fontConfig.xSmall,
        weight: fontConfig.weight.bold,
    },
    tooltip: {
        mergeCss: true,
        extendedStyles: {
            triggerWrapper: {
                css: css`
                    margin-left: 2px;
                    padding-top: 1px;
                `,
            },
        },
        iconProps: {
            size: 12,
        },
    },
};

productPriceStyles.unitOfMeasure = {
    unitOfMeasureText,
};

productPriceStyles.priceLabelText = {
    ...fontConfig.xSmallSingleLine,
    weight: fontConfig.weight.regular,
    transform: "capitalize",
    css: css`
        margin-bottom: 4px;
    `,
};

productPriceStyles.quoteMessageWrapper = {
    css: css`
        display: flex;
        align-items: center;
        gap: 4px;
    `,
};

productPriceStyles.savingsMessageText = {
    variant: "h6",
    forwardAs: "span",
    color: "common.ui4",
    css: css`
        margin-bottom: 0;
        .message {
            text-decoration: line-through;
            margin-right: 4px;
            text-decoration-thickness: 1px;
        }
        .uom {
            font-size: ${fontConfig.xxSmallSingleLine.size}px;
            line-height: ${fontConfig.xxSmallSingleLine.lineHeight};
            font-weight: ${fontConfig.weight.regular};
        }
    `,
};

productPriceStyles.invalidPriceLink = {
    typographyProps: {
        ...fontConfig.smallSingleLine,
        weight: fontConfig.weight.bold,
        css: css`
            text-decoration: underline;
        `,
    },
    css: css`
        width: fit-content;
    `,
};
